import React, { useState } from 'react';
import MagicForm from '../../../Components/Form/MagicForm';
import Loading from '../../../Components/Loading';
import { useEffectAsync } from '../../../helpers';
import useWizardTree from '../../../Hooks/useWizardTree';

interface HealthPlanUserInformationFormProps {
	onSubmit: (values: any) => void;
	userId: string;
	wizardKey?: string;
}

const HealthPlanUserInformationForm: React.FC<
	HealthPlanUserInformationFormProps
> = props => {
	const { onSubmit, userId, wizardKey } = props;

	const [scheme, setScheme] = useState([]);
	const [defaultValues, setDefaultValues] = useState(null);
	const [isInitialized, setIsInitialized] = useState(false);
	const [isCharCounterVisible, setIsCharCounterVisible] = useState(true);

	const { getWizard } = useWizardTree({
		wizardKey: wizardKey ? wizardKey : 'health-plan-patient-information',
		params: {
			userId,
		},
	});

	const handleSubmit = (values: any) => {
		onSubmit(values);
	};

	useEffectAsync(async () => {
		setIsInitialized(false);
		const wizard = await getWizard();
		setScheme(wizard?.children || []);
		setDefaultValues(wizard?.settings?.defaultValues || null);
		setIsCharCounterVisible(wizard?.settings?.showCharCounter || true);
		setIsInitialized(true);
	}, []);

	if (!isInitialized) return <Loading />;

	return (
		<MagicForm
			formScheme={scheme}
			defaultValues={defaultValues}
			onSubmit={handleSubmit}
			showCharCounter={isCharCounterVisible}
		/>
	);
};

export default HealthPlanUserInformationForm;
